import React, { useRef, useEffect, useState } from "react";

// mm → px çevirimi (96 DPI varsayımı — tarayıcı CSS ölçüsüyle uyumlu)
const MM_TO_PX = 96 / 25.4;

const DynamicTextLeftt = ({
  SouthAmerica,
  currencySymbol,
  integerPart,
  currencypl,
  decimalPart,
  top = true,
  className = "helve-condensed", // default: eski font — mevcut etiketler etkilenmez.
  // NEW ZARA piggyback kartları 'helve-bold' (Helvetica Neue LT Std 75 Bold) geçirir.
  // maxWidthMm: yazının maksimum genişliği (mm) — örn. çizgi genişliği.
  // Yazı bu genişliği aşarsa font orantılı küçültülerek sığdırılır.
  maxWidthMm = null,
}) => {
  const containerRef = useRef(null); // İçerik referansı (yazı bloğu)
  const wrapperRef = useRef(null);   // Dış kapsayıcı (genişlik ölçümü için)
  const [fontSize, setFontSize] = useState({ main: "17pt", small: "10pt" }); // Dinamik font boyutu
  const [shrink, setShrink] = useState(1); // oransal küçültme katsayısı (1 = küçültme yok)
  console.log("currro",currencypl);
  useEffect(() => {
    const adjustFontSize = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        if (containerWidth < 70) {
          // 150'den küçük genişlik için
          setFontSize({ main: "17pt", small: "10pt" });
        } else if (containerWidth >= 70 && containerWidth < 100) {
          // 150 ile 200 arasındaki genişlik için
          setFontSize({ main: "17pt", small: "9.41pt  " });
        } else if (containerWidth >= 100) {
          // 200 ve üzeri genişlik için
          setFontSize({ main: "14pt", small: "8.24pt" });
        }
      }
    };
  
    adjustFontSize();
    window.addEventListener("resize", adjustFontSize); // Dinamik ekran boyutlandırma
    return () => window.removeEventListener("resize", adjustFontSize);
  }, []);
  
  // ---- MAX WIDTH SHRINK: yazı maxWidthMm'yi aşarsa fontu orantılı küçült ----
  useEffect(() => {
    if (maxWidthMm == null) {
      setShrink(1);
      return;
    }
    const fitToMax = () => {
      if (!wrapperRef.current) return;
      const maxPx = maxWidthMm * MM_TO_PX;
      const textWidth = wrapperRef.current.scrollWidth;
      if (textWidth > 0 && textWidth > maxPx) {
        // orantılı küçültme — %2 güvenlik payıyla, min 0.5x
        const ratio = Math.max((maxPx / textWidth) * 0.98, 0.5);
        setShrink(ratio);
      } else {
        setShrink(1);
      }
    };
    // Font yüklenmesi/render sonrası ölç — bir frame bekle
    const raf = requestAnimationFrame(fitToMax);
    // ResizeObserver: font veya içerik değişince yeniden ölç
    let ro = null;
    if (typeof ResizeObserver !== 'undefined' && wrapperRef.current) {
      ro = new ResizeObserver(fitToMax);
      ro.observe(wrapperRef.current);
    }
    // İçerik (fiyat metni) değişince de yeniden ölç
    fitToMax();
    return () => {
      cancelAnimationFrame(raf);
      if (ro) ro.disconnect();
    };
  }, [maxWidthMm, currencySymbol, integerPart, decimalPart, currencypl, SouthAmerica, className]);
  
  // pt bazlı font boyutları DOĞAL kalır — küçültme yalnızca CSS transform ile
  // (transform layout'u etkilemediğinden scrollWidth her zaman doğal genişliği
  // verir; bu sayede ölçüm → küçült → yeniden ölç döngüsü yaşanmaz).

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        margin: "0 auto",
      }}
    >
      <div
                  ref={containerRef}

        style={{
          position: "relative",
          overflow: "hidden",
          height: 30,
          paddingTop: 5,
          paddingBottom: 5,
          display: "flex",
          margin: "0 auto",
          justifyContent: "center",
          maxWidth: maxWidthMm != null ? `${maxWidthMm}mm` : undefined,
        }}
      >
        <div
          ref={wrapperRef}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "nowrap",
            transform: `scale(${shrink})`,
            transformOrigin: "center center",
          }}
        >
          <p
            className={className}
            style={{ fontSize: fontSize.main, marginRight: "5px" }}
          >
            {SouthAmerica ? (top ? "AUD$" : "CLP$") : currencySymbol}
          </p>
          <p className={className} style={{ fontSize: fontSize.main }}>
            {integerPart}
          </p>
      {currencypl !== "CLP" && (
            <p
              className={className}
              style={{
                fontSize: fontSize.small,
                marginTop: "-4px",
                marginRight: "4px",
              }}
            >
              {decimalPart}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DynamicTextLeftt;
